import { render } from "./DistributionList.vue?vue&type=template&id=f6c09356&scoped=true"
import script from "./DistributionList.vue?vue&type=script&lang=js"
export * from "./DistributionList.vue?vue&type=script&lang=js"

import "./DistributionList.vue?vue&type=style&index=0&id=f6c09356&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c09356"]])

export default __exports__